import {
  faAddressBook,
  faCircleUser,
  faFireFlameCurved,
  faTag,
} from '@awesome.me/kit-a6e51d954f/icons/classic/regular';

import Clients from './components/Clients';
import ClientFilterButton from './components/Clients/FilterButton';
import { TagList as ClientTagList } from './components/Clients/FilterLists';
import NewClientButton from './components/Clients/NewButton';
import Decedents from './components/Decedents';
import DecedentFilterButton from './components/Decedents/FilterButton';
import {
  OwnerList as DecedentOwnerList,
  TagList as DecedentTagList,
} from './components/Decedents/FilterLists';
import NewDecedentButton from './components/Decedents/NewButton';

export const DROPDOWN_ACTIONS = {
  client: [
    {
      id: 'view-client',
      label: 'View client',
      variant: 'default',
    },
    {
      id: 'edit-client',
      label: 'Edit client',
      variant: 'default',
    },
    {
      id: 'assign-case',
      label: 'Assign case',
      variant: 'default',
    },
    {
      id: 'divider-1',
      type: 'divider',
    },
    {
      id: 'delete-client',
      label: 'Delete client',
      variant: 'destructive',
    },
  ],
  decedent: [
    {
      id: 'view-decedent',
      label: 'View decedent',
      variant: 'default',
    },
    {
      id: 'edit-decedent',
      label: 'Edit decedent',
      variant: 'default',
    },
    {
      id: 'assign-case',
      label: 'Assign case',
      variant: 'default',
    },
    {
      id: 'divider-1',
      type: 'divider',
    },
    {
      id: 'delete-decedent',
      label: 'Delete decedent',
      variant: 'destructive',
    },
  ],
};

export const FILTERS = {
  client: [
    {
      emptyMessage: 'No tags found.',
      icon: faTag,
      label: 'Tag',
      listComponent: ClientTagList,
      searchPlaceholder: 'Search tags...',
      type: 'tags',
    },
  ],
  decedent: [
    {
      emptyMessage: 'No owners found.',
      icon: faCircleUser,
      label: 'Owner',
      listComponent: DecedentOwnerList,
      searchPlaceholder: 'Search owners...',
      type: 'owners',
    },
    {
      emptyMessage: 'No tags found.',
      icon: faTag,
      label: 'Tag',
      listComponent: DecedentTagList,
      searchPlaceholder: 'Search tags...',
      type: 'tags',
    },
  ],
};

export const ERROR_TITLES = {
  client: {
    create: 'Unable to create a client.',
  },
  decedent: {
    create: 'Unable to create a decedent.',
  },
};

export const SUCCESS_MESSAGES = {
  client: {
    create: 'Client created.',
  },
  decedent: {
    create: 'Decedent created.',
  },
};

export const TABS_CONFIG = [
  {
    component: Decedents,
    filterButton: DecedentFilterButton,
    icon: faFireFlameCurved,
    label: 'Decedents',
    newButton: NewDecedentButton,
    value: 'decedents',
  },
  {
    component: Clients,
    filterButton: ClientFilterButton,
    icon: faAddressBook,
    label: 'Clients',
    newButton: NewClientButton,
    value: 'clients',
  },
];
